import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Signal, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TiimeDialogModule, DialogBase, TiimeButtonModule, TiimeAlertModule } from 'tiime-material';

import { ContractsContainerComponent } from '@shared-components/contracts-container/contracts-container.component';

import { SelectContractDialogData } from './select-contract-dialog-data';

@Component({
  selector: 'app-select-contract-dialog',
  standalone: true,
  imports: [CommonModule, TiimeDialogModule, TiimeAlertModule, TiimeButtonModule, ContractsContainerComponent],
  templateUrl: './select-contract-dialog.component.html',
  styleUrls: ['./select-contract-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectContractDialogComponent extends DialogBase<SelectContractDialogComponent> {
  readonly overlayData: Signal<SelectContractDialogData> = signal(inject(MAT_DIALOG_DATA)).asReadonly();
}
